import {
  CurrentToPriorKeysMatch,
  PartialMatch,
  TimePeriodType,
  TimePeriodComparisonType, TimePeriodTypeName,
} from "@/models/timePeriod.model.ts";
import { IOption } from "@/models/shared.model";
import { getPreviousTimePeriods, getTimePeriods } from "@/helpers/timePeriod";
import { isTenantFirstDayOfWeek } from "@/helpers/tenantCalendar";

export const timePeriodFilterService = {
  // True on the tenant's first day of the week (Monday, or Sunday for en-US) in the tenant zone,
  // when "this week" would be a single day and the default period falls back to last week.
  isFirstDayOfWeek: function(): boolean {
    return isTenantFirstDayOfWeek();
  },
  // The period a fresh filter opens on. Both its label and its dates come from here.
  defaultPeriod: function(): TimePeriodType {
    return this.isFirstDayOfWeek() ? TimePeriodType.lastWeek : TimePeriodType.thisWeek;
  },
  isPeriodOptionDisabled: (timePeriod: keyof typeof TimePeriodType, option: keyof typeof TimePeriodComparisonType): boolean => {
    if (option === TimePeriodComparisonType.partialPeriod) {
      return [
        TimePeriodType.today,
        TimePeriodType.lastWeek,
        TimePeriodType.lastMonth,
        TimePeriodType.custom
      ].includes(TimePeriodType[timePeriod as keyof typeof TimePeriodType]);
    }

    return false;
  },
  getFilterOptions: function(): IOption<string>[] {
    const timePeriodFilterOptions = [
      TimePeriodType.today,
      TimePeriodType.thisWeek,
      TimePeriodType.lastWeek,
      TimePeriodType.thisMonth,
      TimePeriodType.lastMonth,
      TimePeriodType.custom,
    ];

    return timePeriodFilterOptions.map(key => {
      const typedKey = key as keyof typeof TimePeriodTypeName;
      return {
        value: key,
        name: TimePeriodTypeName[typedKey],
        tooltip: "",
      };
    });
  },
  getScoringFilterOptions: function(): IOption<string>[] {
    const timePeriodFilterOptions = [
      TimePeriodType.thisWeek,
      TimePeriodType.lastWeek,
      TimePeriodType.thisMonth,
      TimePeriodType.lastMonth,
      TimePeriodType.custom,
    ];

    return timePeriodFilterOptions.map(key => {
      const typedKey = key as keyof typeof TimePeriodTypeName;
      return {
        value: key,
        name: TimePeriodTypeName[typedKey],
        tooltip: "",
      };
    });
  },
  calculateDates: function(period?: TimePeriodType, isPartial = false): ReturnType<typeof this.calculateDates> {
    const selectedPeriod = period || this.defaultPeriod();
    const timePeriods = getTimePeriods();
    const previousTimePeriods = getPreviousTimePeriods();

    if (isPartial) {
      const [startDate, endDate] = timePeriods[selectedPeriod];
      const [previousStartDate, previousEndDate] = previousTimePeriods[PartialMatch[CurrentToPriorKeysMatch[selectedPeriod]]];

      return {
        startDate,
        endDate,
        previousStartDate,
        previousEndDate,
      };
    }

    const [startDate, endDate] = timePeriods[selectedPeriod];
    const [previousStartDate, previousEndDate] = previousTimePeriods[CurrentToPriorKeysMatch[selectedPeriod]];

    return {
      startDate,
      endDate,
      previousStartDate,
      previousEndDate,
    };
  },
};
